import { Component, Input } from '@angular/core';
import { ArrowLeft01Icon, ArrowLeftDoubleIcon } from '@hugeicons/core-free-icons/index';
import { LucideChevronLeft, LucideChevronsLeft, LucideIconInput } from '@lucide/angular';

export interface SidebarBackLink {
  label: string;
  url: string;
}

@Component({
  selector: 'ptl-secondary-sidebar',
  templateUrl: './secondary-sidebar.component.html',
  styleUrls: ['./secondary-sidebar.component.scss'],
})
export class SecondarySidebarComponent {
  @Input() title = '';
  @Input() icon: LucideIconInput;
  @Input() isCollapsed = false;
  @Input() rightSidebar: boolean;
  @Input() backLink: SidebarBackLink | null = null;

  onToggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  protected readonly ArrowLeftDoubleIcon = ArrowLeftDoubleIcon;
  protected readonly ArrowLeft01Icon = ArrowLeft01Icon;
  protected readonly LucideChevronLeft = LucideChevronLeft;
  protected readonly LucideChevronsLeft = LucideChevronsLeft;
}
